import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { dashboardAction, departmentAction } from '../../redux/action';
import { ROUTE } from '../../route/Route';
import BreadCrumb from '../breadcrumb/BreadCrumb';
import SeoAdd from '../Seo/SeoAdd';
import SubmitForm from '../SubmitForm/SubmitForm';
import DepartmentCard from './component/departmentCard';
import { useTranslation } from "react-i18next";
import { DoctorEnquiryform } from '../../constant/validation';

function Departments() {
    const { t } = useTranslation();

    useEffect(() => {
        window?.scrollTo(0, 0);
        return () => { };
    }, []);

    return (
        <>
            <SeoAdd slug={ROUTE.DEPARTMENT} />
            <BreadCrumb page={t("department")} data={{ slug: "", path: "" }} />
            <>
                <section className="bg-white section overview-top pt-3">
                    <div className="container" id="section2">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="overview-wrap">
                                    <div className="text-center"><img src={t("images.department_banner")} style={{ borderRadius: "24px" }} className="scale" alt="" /></div>
                                    <div className="headingmains text-center pb-3">
                                        <h1 className="right aos-init pb-2 mt-3 mt-lg-5">{t("our_department")}</h1>
                                    </div>
                                    <p>{t("department_content1")}</p>
                                    <p>{t("department_content2")}</p>
                                    <p>{t("department_content3")}</p>
                                    <p>{t("department_content4")}</p>
                                    <p>{t("department_content5")}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
                <DepartmentCard />
                <SubmitForm heading={t("reach_out-to_us")} des={""} PageSrc={"Department"} validationSchema={DoctorEnquiryform}/>
            </>
        </>
    )
}

export default Departments
